import React from "react";

import { Zap, ShieldCheck, ThumbsUp, Headphones } from "lucide-react";

import "./Trust.css";

const TrustBar = () => {
  const trustItems = [
    {
      icon: Zap,
      title: "NHANH",
      description: "Nhận tiền sau 3 phút",
    },
    {
      icon: ShieldCheck,
      title: "AN TOÀN",
      description: "Bảo mật",
    },
    {
      icon: ThumbsUp,
      title: "UY TÍN",
      description: "Vài trăm khách hàng mỗi tháng",
    },
    {
      icon: Headphones,
      title: "HỖ TRỢ 24/7",
      description: "Có mặt tận nơi",
    },
  ];

  return (
    <section className="trustbar">
      <div className="trustbar-container">
        {trustItems.map((item, index) => {
          const Icon = item.icon;

          return (
            <div className="trustbar-item" key={index}>
              <div className="trustbar-icon">
                <Icon
                  size={30}
                  strokeWidth={2.8}
                  fill={index === 0 || index === 1 ? "currentColor" : "none"}
                />
              </div>

              <div className="trustbar-text">
                <strong className="trustbar-title">{item.title}</strong>

                <span className="trustbar-description">{item.description}</span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TrustBar;
